var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20C5.73684 20 5 19.2632 5 18V12C5 10.7368 5.73684 10 7 10H17C18.2632 10 19 10.7368 19 12V18C19 19.2632 18.2632 20 17 20H7ZM7 22H17C19.2456 22 21 20.2456 21 18V12C21 9.75439 19.2456 8 17 8H7C4.75439 8 3 9.75439 3 12V18C3 20.2456 4.75439 22 7 22ZM12 13C10.8947 13 10 13.8947 10 15C10 16.1053 10.8947 17 12 17C13.1053 17 14 16.1053 14 15C14 13.8947 13.1053 13 12 13ZM10 9V6C10 4.73684 10.7368 4 12 4C13.2632 4 14 4.73684 14 6V9H16V6C16 3.75438 14.2456 2 12 2C9.75439 2 8 3.75438 8 6V9H10Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOutlined);
export default __webpack_public_path__ + "static/media/lock_outlined.3a13f8a5.svg";
export { ForwardRef as ReactComponent };